import { TextBox } from '../NarusMaterial/TextBox'

import {
  makeAutobindedInput,
  makeValidatedInput
} from './FormBuilder'

export const TextField = ({ onChange, ...restProps }) => {
  const handleOnChange = event => {
    if (onChange) {
      onChange(event.target.value)
    }
  }
  return (
    <TextBox
      {...restProps}
      onChange={handleOnChange}
    />
  )
}

export const TextInput = makeAutobindedInput(makeValidatedInput(TextField))
